import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import {Vuelidate} from "vuelidate";
import moment from "moment";

// Vue Material
import {
  MdButton,
  MdCard,
  MdCheckbox,
  MdContent,
  MdDrawer,
  MdIcon,
  MdList,
  MdRipple,
  MdTabs,
  MdToolbar,
} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(MdButton);
Vue.use(MdCard);
Vue.use(MdCheckbox);
Vue.use(MdContent);
Vue.use(MdDrawer);
Vue.use(MdIcon);
Vue.use(MdList);
Vue.use(MdRipple);
Vue.use(MdTabs);
Vue.use(MdToolbar);

// Vue EasyTable
import "vue-easytable/libs/theme-default/index.css"; // import style
import { VeTable, VePagination, VeIcon, VeLoading, VeLocale } from "vue-easytable"; // import library

Vue.use(VeTable);
Vue.use(VePagination);
Vue.use(VeIcon);
Vue.use(VeLoading);

Vue.prototype.$veLoading = VeLoading;
Vue.prototype.$veLocale = VeLocale;


Vue.use(Vuelidate);

Vue.filter('moment', function (date, format) {
  return moment(date).format(format ?? 'MMMM Do YYYY, h:mm:ss a');
});

Vue.filter('currency', function (value) {
    if (typeof value !== "number") {

        if (value === undefined) {
          return '-';
        }

        const valueAsNumber = Number(value);

        if (isNaN(valueAsNumber)) {
          return value;
        }

        return valueAsNumber;
    }

    let formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
    });

    return formatter.format(value);
});

Vue.filter('bigNumber', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    return new Intl.NumberFormat().format(value);
    // return value.NumberFormat()?.format();
});


Vue.component("reports", require("./components/reports.vue").default);
Vue.component('arrow', require('./components/arrow').default);
Vue.component('menu-bar', require('./components/menu-bar/menu-bar.vue').default);
Vue.component('error', require('./components/error.vue').default);
Vue.component('warning-icon', require('./components/warning-icon').default);
Vue.component('input-field', require('./components/input-field/input-field').default);
Vue.component('refund', require('./components/refund').default);
Vue.component('typeahead', require('./components/type-ahead/type-ahead.vue').default);
Vue.component('toggle', require('./components/toggle').default);
Vue.component('transfer', require('./components/transfer/transfer').default);
Vue.component('tl-form', require('../../ticketlab-form/src/components/Form').default);

Vue.config.productionTip = false

new Vue({
  router: router,
  render: h => h(App)
}).$mount('#app')
